import { DataSource } from '@angular/cdk/collections';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { DevicesList } from '@ottobock/remote-update/domain';
import { BehaviorSubject, merge, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export class DevicesTableDataSource extends DataSource<DevicesList> {
  private dataSubject = new BehaviorSubject<DevicesList[]>([]);
  paginator: MatPaginator | undefined;
  sort: MatSort | undefined;

  constructor(initialData: DevicesList[] = []) {
    super();
    this.dataSubject.next(initialData);
  }

  setDeviceData(data: DevicesList[]): void {
    this.dataSubject.next(data);
  }

    connect(): Observable<DevicesList[]> {
    if (!this.paginator) {
      throw new Error('Please set the paginator before connecting.');
    }

    return merge(
      this.dataSubject.asObservable(),
      this.paginator.page
    ).pipe(
      map(() => this.getPagedData(this.dataSubject.value))
    );
  }

  disconnect(): void {
    this.dataSubject.complete();
  }

  private getPagedData(data: DevicesList[]): DevicesList[] {
    // ⚠️ We are doing server-side pagination,
    // so backend already gives us one page.
    // Just return the data as-is.
    return data;
  }

}
